import React, { FC, useState, useMemo } from 'react';
import { Tooltip, Typography } from '@mui/material';
import PostAudienceListModal from '../../../audience';
import { useTooltipStyles } from '../../hooks/use-tooltip-styles';
import { useAtomValue } from 'jotai';
import { selectedProjectAtom } from 'atoms';
import { IActivityFeedPost } from 'redux-store/api/activity-feed';
import { useGetMeQuery } from 'redux-store/api/auth';
import UsersIcon from 'assets/icons/buttons/users.svg';
import { postItemStyles as styles } from '../../styles/styles';
import { IPost } from '_interfaces/post.interface';

interface IProps {
  post: IActivityFeedPost | IPost;
  projectId?: number;
}

const PostAudience: FC<IProps> = ({ post }) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const classes = useTooltipStyles();
  const selectedProject = useAtomValue(selectedProjectAtom);
  const { data: userMe } = useGetMeQuery();

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const filteredAudienceMembers = useMemo(() => {
    const projectProfiles = selectedProject?.profiles || [];
    const visibility = post.visibility || [-1];

    if (visibility[0] === -2) {
      if (!userMe) return [];
      return [{ avatar: userMe.avatar || '', firstName: userMe.firstName || '', lastName: userMe.lastName || '', roleName: userMe.role || '', profileId: userMe.id }];
    }

    if (visibility[0] === -1) {
      return projectProfiles.map((p) => ({ avatar: p.avatar, firstName: p.firstName, lastName: p.lastName, roleName: p.role, profileId: p.id }));
    }

    return projectProfiles
      .filter((p) => visibility.includes(p.id))
      .map((p) => ({ avatar: p.avatar, firstName: p.firstName, lastName: p.lastName, roleName: p.role, profileId: p.id }));
  }, [selectedProject?.profiles, post.visibility, userMe]);

  return (
    <>
      <Tooltip
        classes={classes}
        placement={'bottom-start'}
        title={
          <>
            {!filteredAudienceMembers.length ? (
              <Typography sx={styles.likeInfo}>
                {`${userMe?.firstName} ${userMe?.lastName}`}
              </Typography>
            ) : (
              filteredAudienceMembers?.slice(0, 10).map((item) => (
                <Typography sx={styles.likeInfo} key={item.profileId}>
                  {`${item.firstName} ${item.lastName}`}
                </Typography>
              ))
            )}
            {filteredAudienceMembers.length > 10 && (
              <Typography sx={styles.likeInfo}>
                {`and ${filteredAudienceMembers.length - 10} more`}
              </Typography>
            )}
          </>
        }
      >
        <UsersIcon onClick={handleOpenModal} />
      </Tooltip>

      <PostAudienceListModal
        userMe={userMe}
        closeAudienceModal={handleCloseModal}
        openAudienceModal={openModal}
        postAudienceMembers={filteredAudienceMembers}
      />
    </>
  );
};

export default PostAudience;
